module.exports = __webpack_public_path__ + "static/media/badge-appstore2.4890da7c.svg";